import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Login } from 'src/app/models/login.model';
import { ArchivedRoster, Roster } from 'src/app/models/Roster/roster.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RostersService } from 'src/app/services/rosters.service';
import { CoverageDetailsComponent } from '../../Roster/dialog/coverage-details/coverage-details.component';

@Component({
  selector: 'app-archived-rosters',
  templateUrl: './archived-rosters.component.html',
  styleUrls: ['./archived-rosters.component.scss']
})
export class ArchivedRostersComponent implements OnInit {
  isLoading: boolean = true;
  login = new Login("", "", "", "", "", "", 0, false,false,false, "");
  archivedRosters: ArchivedRoster[] = [];
  displayedColumns: string[] = ['rosterNo', 'campusName', 'activity', 'checkNo', 'checkAmt', 'checkDate'];

  constructor(
    private _rosterService: RostersService,
    private _authService: AuthenticationService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this._authService.setLogin.subscribe(login => {
      this.login = login;
      if (this.login.userId != '')
        this.getArchivedRosters(this.login);
    });
  }

  getArchivedRosters(login: Login) {
    this.isLoading = true;
    this.archivedRosters = [];
    this._rosterService.getPreviousYearRosters(login.userId, login.accessId, login.accessLevel)
    .subscribe({
      next: (res: ArchivedRoster[]) => {
        if (res && res.length > 0) {
          this.archivedRosters = res;
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Error fetching archived rosters:', error);
        this.isLoading = false;
      }
    });
  }

  onViewRosterDetails(rosterNo: number) {
    const roster: Roster = new Roster(rosterNo, "", "", "", "", "", "", 0, "", 0, "", 0, 0, 0);
    this.dialog.open(CoverageDetailsComponent, {
      width: '1200px',
      data: { roster }
    });
  }

}
